/**
 * Allowlisted pages Stripe embedded checkout may return to. The backend
 * accepts an arbitrary returnUrl, so the frontend constrains the value to
 * these known paths — anything else (including tampered query params)
 * falls back to the default, which also closes off open redirects.
 */
export const CHECKOUT_RETURN_PATHS = {
  thankYou: '/thank-you',
  funnelWelcome: '/funnel-welcome'
} as const;

export type CheckoutReturnPath =
  (typeof CHECKOUT_RETURN_PATHS)[keyof typeof CHECKOUT_RETURN_PATHS];

export const DEFAULT_CHECKOUT_RETURN_PATH = CHECKOUT_RETURN_PATHS.thankYou;

const ALLOWED_RETURN_PATHS: ReadonlySet<string> = new Set(
  Object.values(CHECKOUT_RETURN_PATHS)
);

/**
 * Resolves an untrusted value (e.g. a router query param) to an
 * allowlisted checkout return path, defaulting to /thank-you.
 */
export const resolveCheckoutReturnPath = (value: unknown): CheckoutReturnPath =>
  typeof value === 'string' && ALLOWED_RETURN_PATHS.has(value)
    ? (value as CheckoutReturnPath)
    : DEFAULT_CHECKOUT_RETURN_PATH;
